import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import StatusBadgeCst from "@components/StatusBadgeCst";
import { InitiativeListItem } from "@hooks/useInitiativesPaginatedList";

interface InitiativeRowCstProps {
  initiative: InitiativeListItem;
}

const InitiativeRowCst: React.FC<InitiativeRowCstProps> = ({ initiative }) => {
  const theme = useTheme();
  const isActive = (initiative.status || "").toUpperCase() === "ACTIVE";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {initiative.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.tertiary,
            lineHeight: 1.4,
          }}
        >
          {`ID: ${initiative.id}`}
        </Typography>
      </Box>

      {isActive && <StatusBadgeCst label="Attivo" variant="active" />}
    </Box>
  );
};

export default InitiativeRowCst;
